// Local twin of isKnownOrigin() in src/server/app.ts: tells people before they type that a page
// cannot send reports yet, instead of losing the report at submit. Only a hint – the server decides.
import { originMatchesPatterns } from '../shared/match.ts';
import type { PublicConfig } from '../shared/types.ts';

/** Origin of the report server; data-api may be relative (e.g. "/support"). */
export function serverOrigin(apiBase: string, pageUrl: string): string | undefined {
  try {
    return new URL(apiBase, pageUrl).origin;
  } catch {
    return undefined;
  }
}

/** True if the server will (most likely) accept reports sent from pageOrigin. When in doubt: true. */
export function isPageAccepted(config: PublicConfig, pageOrigin: string, apiOrigin: string | undefined): boolean {
  // Offline fallback or an older server without allowedOrigins: nothing to check against.
  if (config.version === 'offline' || !Array.isArray(config.allowedOrigins)) return true;
  // Same origin, e.g. a proxy installation under /support: what the proxy forwards is invisible here.
  if (pageOrigin === apiOrigin) return true;
  const { allowedOrigins } = config;
  return allowedOrigins.includes(pageOrigin) || originMatchesPatterns(pageOrigin, [...config.tools.flatMap((t) => t.match), ...allowedOrigins]);
}
